import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import { BillingTable, PageBack } from '@hero/web-components';
import { useBillingListApi } from '@hero/api-hooks';
import { useBillingPayManager, useNav } from '@hero/web-hooks';

export default function BillingHistoryPage() {
  const { t } = useTranslation('m-billing');
  const { setPageName } = usePageContext();
  const { navigate } = useNav();
  const billingListQuery = useBillingListApi({});
  const { payBilling } = useBillingPayManager();

  useEffect(() => {
    setPageName(t('billing_doc.title'));
  }, [setPageName, t]);

  return (
    <div className="mt-6 flex flex-col gap-4">
      <PageBack redirect="billing" />
      <BillingTable
        billings={billingListQuery.data ?? []}
        isLoading={billingListQuery.isLoading}
        onRowClick={b => navigate('billing_invoice', { id: String(b._id) })}
        onPay={b => payBilling(b, { openIn: 'tab' })}
        onLoadMore={billingListQuery.onLoadMore}
        hasNextPage={billingListQuery.hasNextPage}
        isFetchingNextPage={billingListQuery.isFetchingNextPage}
      />
    </div>
  );
}
